import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from 'bootstrap';
import { useNavigate } from "react-router-dom";
import clientHttp from '../../components/ClientHttp';
import { formatDateDB } from '../../components/DateUtil';
import { base64ToBlob } from "../../components/DataConvert";

import SaleSummaryData from "./SaleSummaryData";
import { saveAs } from 'file-saver';

export default function SaleSummaryReportContent() {
    const currentDate = new Date();
    const [reportDate, setReportDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1));
    const [fromDate, setFromDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 2));
    const [toDate, setToDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1)); //useState(currentDate);
    const [dateType, setDataType] = useState(2)
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [errorClass, setErrorClass] = useState('');
    let navigate = useNavigate()

    const [isSearchLoading1, setIsSearchLoading1] = useState(false)
    const [isSendmailLoading1, setIsSendmailLoading1] = useState(false)
    const [isSearchLoading2, setIsSearchLoading2] = useState(false)
    const [isSendmailLoading2, setIsSendmailLoading2] = useState(false)
    const [isDownloadLoading2, setIsDownloadLoading2] = useState(false)

    let datePast = parseInt(process.env.REACT_APP_ORDERPAYMENT_DATEPAST)
    let dateForward = (datePast > 2) ? datePast - 2 : 2
    console.log('datePast: ' + datePast)
    const [minDate, setMinDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 2));
    const [maxDate, setMaxDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + dateForward));

    const onDateChange = (newDate) => {
        console.log('select from date: ' + newDate)
        setFromDate(newDate)
        setToDate(new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() + 1))
        setMinDate(newDate)
        setMaxDate(new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() + datePast))
    };

    // DatePicker
    const fromDateCalendar = useRef(null)
    const toDateCalendar = useRef(null)
    const reportDateCalendar = useRef(null)
    async function openFromDateCalendar() { fromDateCalendar.current.setFocus(true); }
    async function openToDateCalendar() { toDateCalendar.current.setFocus(true); }
    async function openReportDateCalendar() { reportDateCalendar.current.setFocus(true); }

    async function searchSubmit(type) {
        if (type === 1) setIsSearchLoading1(true)
        else setIsSearchLoading2(true)
        setDataType(type)
        let isSuccess = false
        // clear data
        setError('')
        setErrorClass('')
        setData(null)


        console.log('call search api with parameters:' + fromDate, toDate, reportDate)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate()
        const _toDate = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate()
        const _reportDate = reportDate.getFullYear() + '-' + (reportDate.getMonth() + 1) + '-' + reportDate.getDate()
        const formData = {
            fromDate: (type === 1) ? _fromDate : _reportDate,
            toDate: (type === 1) ? _toDate : _reportDate,
            dateType: type,
        }
        console.log(formData)
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/salesummary', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then(response => {
                console.log('response status: ' + response.status)
                if (response.data.status === 'success') {
                    console.log('display sale summmary report')
                    setData(response.data)
                    console.log(response)
                    isSuccess = true
                    setErrorClass('text-black')
                } else {
                    console.log('get sale summary report failed: ' + response.data.message)
                    setError(response.data.message)
                    setErrorClass('text-danger')
                }

            }).catch(err => {
                console.log('error: ', err.message)
                if (err.response.status === 401 || err.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('get sale summary report failed: ' + err.message)
                    setError(err.message)
                    setErrorClass('text-danger')
                }
            })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        if (type === 1) setIsSearchLoading1(false)
        else setIsSearchLoading2(false)
    }

    async function downloadSubmit(type) {
        console.log('download report file: ', type)
        setIsDownloadLoading2(true)
        let isSuccess = false
        setError('')
        setErrorClass('')

        //const _reportDate = reportDate.getFullYear() + '-' + (reportDate.getMonth() + 1) + '-' + reportDate.getDate()
        const _reportDate = formatDateDB(reportDate)
        console.log('call search api with parameters:' + _reportDate)
        const formData = {
            reportDate: _reportDate,
        }
        // Send formData object
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/download_salesummary', formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/*'
            },
            responseType: 'json'
            //responseType: 'blob'
        }).then(response => {
            //console.log(JSON.stringify(response))
            console.log(response.headers["content-disposition"])
            let fileName = response.headers["content-disposition"].split("filename=")[1];
            console.log('receive report file: ' + fileName)

            const blob = base64ToBlob(response.data, "application/vnd.ms-excel");
            let url = window.URL.createObjectURL(blob);
            saveAs(url, fileName);

            isSuccess = true;

            //let url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.ms-excel'})); 
            //saveAs(url, fileName);
            /*
            // 1 create file link in browser's memory
            //const href = URL.createObjectURL(response.data);
            // 2
            //const new_blob = new Blob( [ response.data ] );
            //const href = URL.createObjectURL( new_blob );
            var excel_blob = new Blob([response.data], {type:'application/vnd.ms-excel'}); 
            const href = URL.createObjectURL( excel_blob );
            isSuccess = true;

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
            */
        }).catch(error => {
            console.log(error)

            if (error.response.status === 401 || error.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get download report file failed: ' + error.message)
                setError('Failed to export file')
            }
        })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        //await new Promise( res => setTimeout(res, 1000) );
        setIsDownloadLoading2(false)
    }
    async function downloadAPISubmit(type) {
        console.log('download api report file: ', type)
        setIsDownloadLoading2(true)
        let isSuccess = false
        setError('')
        setErrorClass('')

        //https://of0lieevd9.execute-api.ap-southeast-1.amazonaws.com/uat/s3?key=UAT/Report/202505/${filename}
        const _reportDate = formatDateDB(reportDate)
        let arr = _reportDate.split('-')
        let reportFile = `Sales_Summary_Report_${arr[0]}_${arr[1]}_${arr[2]}.xlsx`
        console.log('call download report with file:' + reportFile)

        // Send formData object
        let token = localStorage.getItem('token')
        let reportApi = `${process.env.REACT_APP_REPORT_S3_API}?key=${process.env.REACT_APP_REPORT_S3_PATH}/${arr[0]}${arr[1]}/${reportFile}`
        console.log('call download report with url:' + reportApi)
        await clientHttp.get(reportApi, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/octet-stream'
            },
            responseType: 'blob'
            //responseType: 'arraybuffer'
        }).then(response => {
            console.log('receive report file: ' + reportFile)

            isSuccess = true;
            let url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.ms-excel'})); 
            saveAs(url, reportFile);
            /*
            const buffer = Buffer.from(response.data, 'binary');
            console.log('Report data received');
            // You can save or process the buffer as needed
            const writeStream = fs.createWriteStream(reportFile);
            writeStream.write(buffer);
            writeStream.end();

            writeStream.on('finish', () => {
                console.log('Download report successfully.');
            });
            */

            isSuccess = true;
        }).catch(error => {
            console.log(error)

            if (error.response.status === 401 || error.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get download report file failed: ' + error.message)
                setError('Failed to export file')
            }
        })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        //await new Promise( res => setTimeout(res, 1000) );
        setIsDownloadLoading2(false)
    }    

    async function sendmailSubmit(type) {
        console.log('in develop')
        alert('This function is not available')
        /* comment to disable action
        if (type === 1) setIsSendmailLoading1(true)
        else setIsSendmailLoading2(true)
        setDataType(type)
        let isSuccess = false
        // clear data
        setError('')


        console.log('call search api with parameters:' + fromDate, toDate)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate()
        const _toDate = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate()
        const _reportDate = reportDate.getFullYear() + '-' + (reportDate.getMonth() + 1) + '-' + reportDate.getDate()
        const formData = {
            fromDate: (type === 1) ? _fromDate : _reportDate,
            toDate: (type === 1) ? _toDate : _reportDate,
            dateType: type,
            email: localStorage.getItem('email'),
            username: localStorage.getItem('name'),
        }
        console.log(formData)
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/sendmail_salesummary', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
                console.log('response status: ' + response.status)
                if (response.data.status === 'success') {
                    console.log('sendmail sale summmary report')
                    console.log(response.data)
                    isSuccess = true
                } else {
                    console.log('sendmail sale summary report failed: ' + response.data.message)
                }
                setError(response.data.message)

            }).catch(err => {
                console.log('error: ', err.message)
                if (err.response.status === 401 || err.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('sendmail order_status failed: ' + err.message)
                    setError(err.message)
                }
            })

        //if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        //}
        if (type === 1) setIsSendmailLoading1(false)
        else setIsSendmailLoading2(false)
        */
    }

    useEffect(() => {
        // first enter then call search with current month
        searchSubmit(2)
    }, [])

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    {/* start form */}
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">From Date:</span>
                                            <DatePicker className="form-control" ref={fromDateCalendar} selected={fromDate} onChange={onDateChange} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openFromDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>

                                            <span className="input-group-text ms-3">To Date:</span>
                                            <DatePicker className="form-control" ref={toDateCalendar} selected={toDate} minDate={minDate} maxDate={maxDate} onChange={(date) => setToDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openToDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading1 ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this, 1)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                        {isSendmailLoading1 ?
                                            <button className="btn btn-black btn-border ms-3" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-black btn-border ms-3" style={{ "width": "120px" }} onClick={sendmailSubmit.bind(this, 1)}>
                                                Send Email <i className="bi bi-send ms-2"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div><hr /></div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Report Date:</span>
                                            <DatePicker className="form-control" ref={reportDateCalendar} selected={reportDate} onChange={(date) => setReportDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openReportDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading2 ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this, 2)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                        {isDownloadLoading2 ?
                                            <button className="btn btn-black btn-border ms-3" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-black btn-border ms-3" style={{ "width": "120px" }} onClick={downloadSubmit.bind(this, 2)}>
                                                Download <i className="bi bi-download ms-2"></i>
                                            </button>
                                        }
                                        {isSendmailLoading2 ?
                                            <button className="btn btn-black btn-border ms-2" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-black btn-border ms-2" style={{ "width": "120px" }} onClick={sendmailSubmit.bind(this, 2)}>
                                                Send Email <i className="bi bi-send ms-2"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end form */}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <SaleSummaryData reportDate={reportDate} fromDate={fromDate} toDate={toDate} dateType={dateType} data={data} />
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorClass}>{error}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}